import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

interface UseClientUserShowConsumptionPasswordProps {
  userId?: string;
  enabled?: boolean;
}

export const useClientUserShowConsumptionPassword: (props: UseClientUserShowConsumptionPasswordProps) => UseQueryResult<{ consumption_password: string }, unknown> = ({ userId, enabled }: UseClientUserShowConsumptionPasswordProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    enabled,
    queryKey: ['clientUsersShowConsumptionPassword', userId],
    queryFn: async () => {
      return await privateAxios.get(`/client/users/${userId}/show_consumption_password`);
    },
    select: (data) => data?.data?.data,
  });
};
